import React, { useEffect, useState } from "react";
import * as moment from "moment";
import { calculate } from "../../helpers/calculate";
import homeIcon from "../../images/icons/homevector.svg";
import WhiteHeader from "../../components/Navigation/WhiteHeader";
import { useHistory } from "react-router-dom";
import { Calculate } from "./calculate";
import { useAnalytics } from "../../context/analytics.context";
import { ShowEToast } from "../../context/compressor";
import Loading from "../../components/Loader";
import loanCalculator, { loan_details, loan_period } from "./loanCalculator";
// import { branches } from '../../LoadInfo/branches';

function LoanEstimate() {
  const payment_type = [
    {
      id: 1,
      value: 1,
      name: "Reducing Balance",
    },
    {
      id: 2,
      value: 2,
      name: "Constant Installment",
    },
  ];

  let amountpayable = 0.0;
  let interestpaid = 0.0;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const defaultLoan = loan_details[0];
  const defaultRepayment = loan_period[0];

  const [amount, setAmount] = useState(0);
  const [period, setPeriod] = useState(defaultRepayment);
  const [loanT, setLoanT] = useState(-1);
  const [paymentType, setPaymentType] = useState(1);
  const [Rate, setRate] = useState(1);
  const [table, setTable] = useState([]);
  const [maxPeriod, setMaxPeriod] = useState(96);
  const [totalAmount, setTotalAmount] = useState(0.0);
  const [amountP, setAmountP] = useState(0.0);
  const [interestP, setInterestP] = useState(0.0);
  const { createAnalytics } = useAnalytics();
  const [selectedLoan, setSelectedLoan] = useState(defaultLoan);
  const [spinner, setSpinner] = useState(false);
  const [summary, setSummary] = useState(null);
  const [level, setlevel] = useState(0);
  const [date, setDate] = useState(null);
  // loan ids for constant balance
  let fosaPrideId = 6,
    jijenge19 = 5;

  useEffect(() => {
    return () => {
      setlevel(0);
      setAmount(0);
      setPeriod(defaultRepayment);
      setSelectedLoan(defaultLoan);
    };
  }, []);
  useEffect(() => {
    if (selectedLoan.id > 0) {
      setlevel(1);
      setAmount(0);
      setPeriod(defaultRepayment);
      // setPeriod(0);
    }
  }, [selectedLoan?.id]);

  useEffect(() => {
    if (amount) {
      setlevel(2);
      setPeriod(defaultRepayment);
    }
  }, [amount]);
  useEffect(() => {
    if (period.id > 0) setlevel(3);
  }, [period]);

  const handleSelectedLoan = (e) => {
    const { value } = e.target;

    if (value === 0 + "") return;

    const newVal = loan_details.find((loan) => loan.id === +value);
    setLoanT(newVal.id);
    setSelectedLoan(newVal);
    setRate(newVal.interest_rate);
    setMaxPeriod(newVal.max_period);
    if (
      newVal.loan_type === "Jijenge 25" ||
      newVal.loan_type === "Jijenge 19"
    ) {
      setLoanT(1);
    }
    if (newVal.loan_type === "Fosa Pride Loan") {
      setLoanT(2);
    }
  };

  const handleCalculate = () => {
    const _amount = handleNumber(amount);

    if (selectedLoan.id <= 0) {
      ShowEToast("Select loan type");
    } else if (Number.isNaN(Number(_amount))) {
      ShowEToast("Enter a numeric value");
    } else if (Number(amount) <= 0) {
      ShowEToast("Enter an amount");
    } else if (period.value === 0) {
      ShowEToast("Select repayment period");
    } else {
      const isConstant =
        selectedLoan.id === fosaPrideId || selectedLoan.id === jijenge19
          ? true
          : false;
      const valz = Calculate(
        Number(_amount),
        Number(period.value),
        Number(loanT),
        Number(paymentType),
        Number(Rate)
      );
      setTable([]);

      const results = loanCalculator({
        amount: _amount,
        period: +period.value,
        rate: +Rate,
        isConstant,
        date,
      });

      console.log("[table]", valz, results);
      // set this spinner just for visuals
      setSpinner(true);
      setTimeout(() => {
        setTable(results);
        handleDisplayValues(results);
        //setTable(valz);
        //handleDisplayValues(valz);

        document.getElementById("table").scrollIntoView({ behavior: "smooth" });
        createAnalytics({
          category: "calculator",
          action: amount,
          label: period,
        });
        setSpinner(false);
      }, 3000);
    }
  };

  const handleDisplayValues = (values) => {
    let amnt = 0;
    let princ = 0;
    let total = 0;

    if (values.length) {
      values.map((v) => {
        amnt += v.principal;
        princ += v.interest;
        total += v.principal + v.interest;
      });
    }
    setSummary({ amnt, princ, total, yourPayment: values[0]?.yourPayment });
    setAmountP(Math.round(amnt / 10) * 10);
    setInterestP(princ);
    setTotalAmount(total);
  };

  const { location, push, goBack } = useHistory();

  const handleLoan = () => {
    createAnalytics({
      category: "apply after calculator",
      action: location?.state?.home ? "Home button" : "Somewhere tu",
    });
    // console.log(location);
    if (location.state?.product) goBack();
    else push("/user/member_login");
  };
  const handleNumber = (val, toString = false) => {
    if (toString) {
      if (String(val).includes(",")) {
        let num = val.split(",").join("");
        if (Number.isNaN(+num)) return 0; // if a letter was entered
        return Number(num).toLocaleString();
      }
      return Number(val).toLocaleString();
    } else {
      return Number(val.split(",").join(""));
    }
  };
  const handleDate = (e) => {
    const date = e.target.value;

    if (date) {
      let leo = new Date().toLocaleDateString();
      if (new Date(date).getTime() >= new Date(leo).getTime()) {
        setDate(date);
      } else ShowEToast("Select today or a date in future");
    } else {
      ShowEToast("Select a valid date");
    }
  };

  let breadcrumbs = [{ name: "Loan Estimate", href: "/" }];
  return (
    <div>
      <WhiteHeader breadcrumbs={breadcrumbs} />

      <div className="container">
        <h2 id="subheader" className="py-4">
          Loan Calculator
        </h2>

        <div
          className="row justify-content-center align-items-start col-12 col-md-12 my-3 px-3"
          // style={{ borderRadius: 1, minHeight: '140vh' }}
        >
          <div
            className="col-12 col-md-6 align-items-center justify-content-center"
            // style={{border: '1px solid #979797', height: '70vh'}}
          >
            {/**select type of loan */}
            <div className="col-12 col-md-10 py-2 mb-4">
              <label htmlFor="loan-type" className="form-label">
                <small>Loan type</small>
              </label>
              <select
                id="loan-type"
                style={{ color: "#263238", fontWeight: "bold" }}
                className="form-select"
                onChange={handleSelectedLoan}
                value={selectedLoan.id}
              >
                {/*<option value={loanT} selected>
                  Select Loan Type
                </option>*/}
                {loan_details.map((loan) => {
                  return (
                    <option key={loan.id} value={loan.id}>
                      {loan.loan_type}
                    </option>
                  );
                })}
              </select>
            </div>
            {level > 0 && (
              <div className="col-12 col-md-10 py-2 bg-success text-white p-3 mb-2">
                <p>
                  Interest rate: <b className="pl-2">{Rate + " %"}</b>
                </p>
                <p>
                  Loan Period:{" "}
                  <b className="pl-2 ml-2">
                    {selectedLoan?.max_period ?? "-"} months
                  </b>
                </p>
                <p>
                  Loan Type:{" "}
                  <b className="pl-2">
                    {selectedLoan?.id === fosaPrideId ||
                    selectedLoan?.id === jijenge19
                      ? "Constant installment"
                      : "Reducing Balance"}{" "}
                  </b>
                </p>
              </div>
            )}

            {level > 0 && (
              <div className="col-12 col-md-10 py-2">
                <label htmlFor="loan-amount" className="form-label">
                  <small>Amount you wish to borrow</small>
                </label>

                <input
                  // type="number"
                  className="form-control"
                  id="loan-amount"
                  style={{ fontWeight: amount ? "bold" : "normal" }}
                  placeholder="Indicate amount"
                  value={handleNumber(amount, true)}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>
            )}
            {level > 1 && (
              <>
                <div className="col-12 col-md-10 py-2">
                  <label htmlFor="loan-period" className="form-label">
                    <small>Repayment period (in months)</small>
                  </label>
                  <select
                    id="loan-period"
                    style={{ color: "#263238", fontWeight: "bold" }}
                    className="form-select"
                    onChange={(e) => {
                      setPeriod(
                        loan_period.find((p) => p.value === +e.target.value)
                      );
                    }}
                    value={period.value}
                  >
                    {loan_period.map((p) => {
                      if (p.value <= maxPeriod) {
                        return (
                          <option key={p.id} value={p.value}>
                            {p.period}
                          </option>
                        );
                      }
                    })}
                  </select>
                </div>
                {period.value > 0 && (
                  <div className="col-12 col-md-10 py-2 mb-1">
                    <label htmlFor="date" className="form-label">
                      <small>
                        Enter date you wish to borrow a loan (optional)
                      </small>
                    </label>

                    <input
                      // type="number"
                      className="form-control"
                      type="date"
                      id="date"
                      //style={{ fontWeight: amount ? "bold" : "normal" }}
                      value={date}
                      onChange={handleDate}
                    />
                  </div>
                )}
              </>
            )}

            {/*level > 2  && (
              <section>
                <hr />
                <div className="col-12 col-md-10 py-2">
                  <label for="interset-rate" className="form-label">
                    <small>Interest rate</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="interset-rate"
                    // placeholder={Rate}
                    readOnly
                    style={{ cursor: "not-allowed", fontWeight: 600 }}
                    onChange={(e) => setRate(e.target.value)}
                    value={Rate + " %"}
                  />
                </div>
                <div className="col-12 col-md-10 py-2">
                  <label for="payment-type" className="form-label">
                    <small>Loan payment type</small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="payment-type"
                    placeholder=""
                    style={{
                      color: "#263238",
                      fontWeight: "bold",
                      cursor: "not-allowed",
                    }}
                    value={
                      selectedLoan.id === fosaPrideId ||
                      selectedLoan.id === jijenge19
                        ? "Constant installment"
                        : "Reducing Balance"
                    }
                    //onChange={(e) => setAmount(e.target.value)}
                    disabled={false}
                  />
                  {/* <select
                id="inputState"
                style={{ color: "#263238", fontWeight: "bold" }}
                className="form-select"
                onChange={(e) => setPaymentType(e.target.value)}
              >
                {payment_type.map((payment) => (
                  <option key={payment.id} value={payment.value}>
                    {payment.name}
                  </option>
                ))}
              </select>
                </div>
              </section>
            )*/}

            <div
              className="col-12 col-md-10 text-center py-2"
              style={{ display: level > 2 ? "block" : "none" }}
            >
              <button
                className="col-12 btn btn-outline rounded"
                type="submit"
                onClick={handleCalculate}
                disabled={spinner}
              >
                {spinner ? "Calculating" : "Calculate"}
              </button>
            </div>
          </div>
          {spinner ? (
            <div
              className="col-12 col-md-6 col-sm-12 text-white "
              style={{ backgroundColor: "#ccc", height: "70vh" }}
            >
              <Loading />
            </div>
          ) : (
            <div
              className="col-12 col-md-6 col-sm-12 text-white box-g "
              style={{
                backgroundColor: "#067C4B",
                height: "70vh",
                //visibility: table.length > 0 ? "visible" : "hidden",
              }}
            >
              <div style={{ height: "33%" }} className="py-5 text-center">
                <p id="subheader" className="" style={{ fontWeight: "500" }}>
                  Amount
                </p>
                {/* <h1>{totalAmount !== 0.0 ? (totalAmount/Number(period)).toFixed(2) : 0.0}</h1> */}
                <h2>KES. {amountP.toLocaleString()}</h2>
              </div>
              <div style={{ height: "33%" }} className="pt-3 text-center">
                <p id="subheader" className="" style={{ fontWeight: "500" }}>
                  Interest
                </p>

                <h2>KES. {interestP.toLocaleString()}</h2>
              </div>

              <div style={{ height: "33%" }} className="pt-3 text-center">
                <p id="subheader" className="" style={{ fontWeight: "500" }}>
                  Amount + Interest
                </p>

                <h2>KES. {(amountP + interestP)?.toLocaleString()}</h2>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="container">
        <div>
          <small className="col-11 py-3 my-2">
            Disclaimer: This calculator is made available to you as a self-help
            tool for your independent use. The repayment results in every case
            are an approximate guide only
          </small>

          <div className="py-5" id="table">
            {!!table.length ? <ResutlsTable results={table} /> : null}

            {!!amountP && (
              <div style={{ height: "33%" }} className="pt-3 text-center">
                <ApplyLoanButton handleLoan={handleLoan} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoanEstimate;
const ResutlsTable = ({ results = [] }) => {
  const sumAll = (results, key) => {
    let total = results.reduce((a, b) => (a += b[key]), 0);

    if (Number.isNaN(Number(total))) return "-";
    return (Math.round(total / 10) * 10).toLocaleString();
  };
  return (
    <div className="table-responsive-sm">
      <table
        className="table table-bordered table-hover "
        style={{ width: "90%", margin: "auto", borderCollapse: "collapse" }}
      >
        <thead>
          <th scope="col">Month</th>
          <th scope="col">Your Monthly Payment (KES)</th>
          <th scope="col">Principle payment (KES)</th>
          <th scope="col">Interest (KES)</th>
          <th scope="col">Balance (KES)</th>
          <th scope="col">Repayment date</th>
        </thead>
        <tbody>
          {/*<tr>
          {" "}
          <td colSpan={4}></td>
          <td>{sumAll(results, "yourPayment")} </td>
        </tr>*/}
          {results.map((t) => {
            return (
              <tr key={t.month}>
                <td>{t?.month}</td>
                <td>{t?.yourPayment?.toLocaleString()}</td>
                <td>{t?.principal.toLocaleString()}</td>
                <td>{t?.interest?.toLocaleString()}</td>

                <td>{t?.balance?.toLocaleString()} </td>
                <td>{t?.when} </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td>#</td>
            <td style={{ fontWeight: 600 }}>
              {sumAll(results, "yourPayment")}
            </td>
            <td style={{ fontWeight: 600 }}>{sumAll(results, "principal")}</td>
            <td style={{ fontWeight: 600 }}>{sumAll(results, "interest")}</td>
            {/* <td style={{ fontWeight: 600 }}>- </td>*/}
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

const ApplyLoanButton = ({ handleLoan = (f) => f }) => {
  const [clicked, setClicked] = React.useState(false);
  return (
    <button
      className="btn btn-member my-2"
      style={{
        zIndex: 100,
        transition: "all 2000s linear",
        width: clicked ? 300 : 200,
      }}
      onClick={() => {
        handleLoan();
        setClicked(!clicked);
      }}
    >
      Apply loan
    </button>
  );
};
